// extracted by mini-css-extract-plugin
export default {"previewCustom":"EmailStructure_previewCustom__sapIv","emailStructureCardBody":"EmailStructure_emailStructureCardBody__VB3H4"};